//TODO entries having subentries
class FilteredDropdown {
    constructor(element, quickDeleteAreaElement, filterData, options) {
        this.filterData = filterData;
        this.entries = filterData.options;

        this.entries = this.entries.filter(function(element){
            if(element.hasOwnProperty('startDate')){
                let startDate = new Date(element.startDate);
                startDate.setDate(startDate.getDate() + SalesToolkit.Theme.getIntegerProperty('optionStartDateOffset', 0));  
                let now = new Date();

                if(startDate > now)
                    return false;
            }

            if(element.hasOwnProperty('expiryDate')){
                let endDate = new Date(element.expiryDate);
                endDate.setDate(endDate.getDate() + SalesToolkit.Theme.getIntegerProperty('optionEndDateOffset', 0));
                let now = new Date();

                if(now >= endDate)
                    return false;
            }

            return true;
        });
        
        if(this.entries.length > 0 && !this.entries[0].hasOwnProperty('name') && this.entries[0].hasOwnProperty('value'))
        {
            let entries = this.entries.map( x => {
                x.name = x.value;
                return x
                });

                this.entries = entries;
        }

        this.defaultOptions = {
            multiSelect: true,
            showSelectionCount: true,
            showZeroSelectionCount: false,
            showResults: true,
            maxItems: 15,
            maxHeight: (16 * 39 + 20),
            allowSearchTerms: true,
            backgroundImagePadding: 0,
            showClearAllButton: true,
            hideEntriesWithZeroResults: true,
            itemPaddingTopBottom : 12,
            quickDeleteHeight: 30,
            quickDeletePadding: '5px 10px',
            localOnly: false,
            width:"auto",
            buttonTopBottomPadding: 10,
            ignoreMaxItemsWithSubOptions: true,
            includeSubOptionsInMaxItems: false,
            accordionDefaultOpen: true,
        }

    
        
        this.options = Object.assign({}, this.defaultOptions, options);
        this.allowedEntries = null;
        this.uid = this.uuidv4();
        this.parentElement = element;
        this.quickDeleteAreaElement = quickDeleteAreaElement;
        this.parentElement.setAttribute('data-filtered-dropdown-id', this.uid);
        this.filtered = false;
        this.selectedItems = [];

        window[this.uid] = this;


        document.addEventListener('click', (event) => {
            const withinBoundaries = event.composedPath().includes(this.wrapper)

            if (!withinBoundaries) {
                this.hideDropdown();
            }
        })
        this.buildUI();

    }

    show(style) {
        this.parentElement.style.display = (style || 'block');
    }


    hide() {
        this.parentElement.style.display = 'none';
    }

    getTranslation(key, defaultValue) {
        if (window.AtheneumInstance) {
            return window.AtheneumInstance.Translation.get(key, defaultValue);
        } else {
            return defaultValue
        }
    }

    getBooleanTheme(key, defaultValue) {
        if (window.AtheneumInstance) {
            return window.AtheneumInstance.Theme.getBooleanProperty(key, defaultValue);
        } else {
            return defaultValue
        }
    }

    getIntTheme(key, defaultValue) {
        if (window.AtheneumInstance) {
            return window.AtheneumInstance.Theme.getIntegerProperty(key, defaultValue);
        } else {
            return defaultValue
        }
    }


    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    htmlToElement(html) {
        let template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content.firstChild;
    }

    getTranslatedLabel(item){
        if(!item.hasOwnProperty('label'))
            return '';
        
        let userLanguage = SalesToolkit.User.getLanguage() || SalesToolkit.Language.getBrowserPreferred() || SalesToolkit.Language.getDefault();
        
        if(!item.hasOwnProperty('translations') || item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0) == -1){
            return item.label;
        }
        
        let index = item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0);
        
        if(index < 0)
            return item.label;
    
        return item.translations[index].label || item.label;
    }

    buildUI() {
        let width = this.options.width;
        this.wrapper = this.htmlToElement("<div class='filteredDropdown' style='width:"+width+"' id='" + this.uid + "MainWrapper'></div>");

        let buttonImagePadding = this.options.backgroundImagePadding;
        let buttonTopBottomPadding = this.options.buttonTopBottomPadding;
      
        let contentWidth = width;
        if(contentWidth === 'auto')
            contentWidth = "auto";

        if (contentWidth === 'auto' && this.getIntTheme('fdContentMaxWidth', 0) > 0) {
            contentWidth = 'auto; max-width:' + this.getIntTheme('fdContentMaxWidth', 0) + 'vw;';
        }

        this.headerDiv = this.htmlToElement("<div style='padding-top: "+buttonTopBottomPadding+"px; padding-bottom:"+buttonTopBottomPadding+"px; padding-right:" + (16 + buttonImagePadding) + "px;' onclick='window[\"" + this.uid + "\"].toggleDropdown()' class='filteredDropdownBtn'>" + this.getTranslatedLabel(this.filterData) + "<span class='countText'></span></div>");
        this.dropdownContent = this.htmlToElement("<div style='width:"+contentWidth+" ' class='filteredDropdown-content'></div>");
        this.searchInput = this.htmlToElement('<input type="text" placeholder="' + this.getTranslation('searchFiltersPlaceholder', 'Search...') + '" class="filteredDropdownSearchInput" oninput="window[\'' + this.uid + '\'].filterItems()">');
        this.resultsText = this.htmlToElement('<span class="resultsText"></span>')
        this.loadingWheel = this.htmlToElement('<div class="loading-wheel"><div class="lds-roller filters"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>');
        this.dropdownItems = this.htmlToElement('<div class="filteredDropdown-items" style="max-height:' + this.options.maxHeight + 'px"></div>');
        this.clearAllButton = this.htmlToElement("<div onclick='window[\"" + this.uid + "\"].clearAllSelected(true)' class='clearAllButton'>" + this.getTranslation('filterClearAllOption', 'Clear All') + "</div>");

        this.dropdownContent.appendChild(this.searchInput);
        this.dropdownContent.appendChild(this.loadingWheel);
        this.dropdownContent.appendChild(this.dropdownItems);
        if (this.options.showClearAllButton) {
            this.dropdownContent.appendChild(this.clearAllButton);
        }
        this.dropdownContent.appendChild(this.resultsText);

        this.resultsText.style.display = 'none';

        this.wrapper.appendChild(this.headerDiv);
        this.wrapper.appendChild(this.dropdownContent);

        this.parentElement.appendChild(this.wrapper);

        this.renderEntries(this.entries);
    }

    hideAllDropdowns(){
        //Only show one at a time
        if (!this.headerDiv.classList.contains('filteredDropdownActive')) {
            let nodeList = document.querySelectorAll('.filteredDropdownActive');
            let i;
            for (i = 0; i < nodeList.length; i++) {
                nodeList[i].classList.remove('filteredDropdownActive');
            }
        }
    }

    /* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
    toggleDropdown() {
        //Only show one at a time
        if (!this.dropdownContent.classList.contains('filteredDropdownShow')) {
            let nodeList = document.querySelectorAll('.filteredDropdownShow');
            let i;
            for (i = 0; i < nodeList.length; i++) {
                nodeList[i].classList.remove('filteredDropdownShow');
            }
        }

        this.hideAllDropdowns();

        if(!this.options.localOnly &&  this.getBooleanTheme('useLinkedFilters', true) && window.AtheneumInstance){
            let atheneum = window.AtheneumInstance;
            this.dropdownContent.classList.toggle('loading', true);
            this.dropdownContent.classList.toggle("filteredDropdownShow");
            this.headerDiv.classList.toggle("filteredDropdownActive");

            let activeFilters = {};
            let i;
            let keys = Object.keys(atheneum.Filters.activeFilters);
            
            for(i=0; i< keys.length; i++){
                activeFilters["applied_"+keys[i]] = atheneum.Filters.activeFilters[keys[i]];
            }

            activeFilters.activeFilter = this.filterData.name;

            let filteredDropdown = this;

            atheneum.API.getFilteredFilters(activeFilters, {
                success: function (json) {
                    if(json.filters.length == 0 ||json.filters.length > 1){
                        filteredDropdown.allowedEntries = null;
                        filteredDropdown.renderEntries(filteredDropdown.entries);
                        filteredDropdown.dropdownContent.classList.toggle('loading', false);
                    }else{
                        filteredDropdown.allowedEntries = json.filters[0].options;
                        filteredDropdown.renderEntries(filteredDropdown.entries);
                        filteredDropdown.dropdownContent.classList.toggle('loading', false);
                    }
                },
                failure: function (reason, httpStatus, errorCode) {
                    let message = atheneum.Translation.get('linkedFiltersFailed', "Could not apply linked filters. This function is only available online.");
                    let title = atheneum.Translation.get('linkedFiltersFailedTitle', "Error");
                
                    SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
                    filteredDropdown.allowedEntries = null;
                    filteredDropdown.renderEntries(filteredDropdown.entries);
                    filteredDropdown.dropdownContent.classList.toggle('loading', false);
                }
            })
        }else{
            this.dropdownContent.classList.toggle("filteredDropdownShow");
            this.headerDiv.classList.toggle("filteredDropdownActive");
            this.allowedEntries = null;
           this.renderEntries(this.entries);
        }

        
    }

    hideDropdown() {
        this.dropdownContent.classList.remove("filteredDropdownShow");
        this.headerDiv.classList.remove("filteredDropdownActive");
    }

    filterItems() {
        let filter, a, i;
        filter = this.searchInput.value.toUpperCase();

        let startsWith = false;
        let endsWith = false;
        let showSelected = false;
        let showEmpty = false;
        
        if (this.options.allowSearchTerms && filter.startsWith('STARTSWITH:')) {
            filter = filter.replace('STARTSWITH:', '');
            startsWith = true;
        } else if (this.options.allowSearchTerms && filter.startsWith('ENDSWITH:')) {
            filter = filter.replace('ENDSWITH:', '');
            endsWith = true;
        } else if (this.options.allowSearchTerms && filter.startsWith('SELECTED:')) {
            filter = filter.replace('SELECTED:', '');
            showSelected = true;
        }   else if (this.options.allowSearchTerms && filter.startsWith('SHOWEMPTY:')) {
            filter = filter.replace('SHOWEMPTY:', '');
            showEmpty = true;
        } 


        if(showEmpty){
            this.filtered = true;
            this.renderEntries(this.entries, true);
            return;
        }

        if (!showSelected && !startsWith && !endsWith && filter.length < 3) {
            if (this.filtered) {
                this.filtered = false;
                this.renderEntries(this.entries);
            }
            return;
        }

        this.filtered = true;

        a = this.entries;
        let entriesToShow = [];

        for (i = 0; i < a.length; i++) {
            let entry = a[i];
            let txtValue = this.getTranslatedLabel(entry);

            let optionsToShow = [];
            let showEntryFromSubEntry = false;
            if(entry.hasOwnProperty('options') && entry.options.length > 0){
                for(let j = 0; j < entry.options.length; j++){
                    let subEntry = entry.options[j];
                    let txtValue = this.getTranslatedLabel(subEntry);

                    if ((startsWith && txtValue.toUpperCase().startsWith(filter)) ||
                        (endsWith && txtValue.toUpperCase().endsWith(filter)) ||
                        (showSelected && this.selectedItems.indexOf(subEntry.name) >= 0) ||
                        (!startsWith && !endsWith && !showSelected && txtValue.toUpperCase().indexOf(filter) > -1)) {
                        
                        optionsToShow.push(subEntry);
                        showEntryFromSubEntry = true;
                    } 
                }

                entry.optionsToShow = optionsToShow;
            }

            if (showEntryFromSubEntry ||
                (startsWith && txtValue.toUpperCase().startsWith(filter)) ||
                (endsWith && txtValue.toUpperCase().endsWith(filter)) ||
                (showSelected && this.selectedItems.indexOf(entry.name) >= 0) ||
                (!startsWith && !endsWith && !showSelected && txtValue.toUpperCase().indexOf(filter) > -1)) {
                entriesToShow.push(a[i]);
            } 

           
        }

        this.renderEntries(entriesToShow);
    }

    renderEntries(entriesToShow, forceEmpty = false) {
        let filter = this.searchInput.value.toUpperCase();
        if (filter.length >= 3 && !this.filtered) {
            this.filterItems();
        }


        this.dropdownItems.innerHTML = "";
      
        let i;

        let fD = this;

         if(this.getBooleanTheme('sortByOptionNumbers', true)){
             this.entries.sort(function(a, b){
                return fD.getFilterOptionsNumbers(b)-fD.getFilterOptionsNumbers(a);
            });    
         }
     
        let c = 0;
        let fc = 0;
        let anySubOptions = entriesToShow.filter(x=> x.hasOwnProperty('options') && x.options.length > 0).length > 0;

        for (i = 0; i < entriesToShow.length; i++) {
            if ((!anySubOptions || (anySubOptions && !this.options.ignoreMaxItemsWithSubOptions)) && c == this.options.maxItems)
                break;
                
            let entry = entriesToShow[i];
            if(this.allowedEntries !== null && !this.allowedEntries.some(x=> x.name === entry.name)){
                //Given the already selected filters this entry is not allowed to be shown
                
                continue;
            }else if(this.allowedEntries !== null){
                let optionsToShow = [];
                if(entry.hasOwnProperty('optionsToShow')){
                    optionsToShow = entry.optionsToShow; 
                }
                entry = this.allowedEntries.find(x=> x.name === entry.name);
                if(this.filtered && optionsToShow.length > 0){
                    entry.optionsToShow = optionsToShow;
                }else{
                    delete entry.optionsToShow;
                }
            }

            let hasSubOptions = entry.hasOwnProperty('options') && entry.options.length > 0;
            let hasSubOptionsText = hasSubOptions? "headerOption" : "";
            let selected = "";
            if (this.selectedItems.some(x => x === entry.name))
                selected = "selected";

            let count = this.getFilterOptionsNumbers(entry);
            if (selected !== "selected" && count == 0 && this.options.hideEntriesWithZeroResults && !forceEmpty) {
                continue;
            }

            let accordionDefault = '';
            let accordionDisplay = '0'
            if(this.options.accordionDefaultOpen){
                accordionDefault = 'open';
                accordionDisplay = 'auto';
            }
            
             let entryHtml = this.htmlToElement('<a style="padding-top:'+ this.options.itemPaddingTopBottom + 'px; padding-bottom:'+ this.options.itemPaddingTopBottom +'px;" class="dropdown_' + entry.name + ' ' + selected + ' '+ hasSubOptionsText +'" onclick="window[\'' + this.uid + '\'].selectedEntry(\'' + entry.name + '\', this, true, null, event);">' + (this.getTranslatedLabel(entry)) + '<span class="countText"></span> <div data-entry-name="'+entry.name+'" class="'+accordionDefault+' accordion-button"></div></a>');
            this.dropdownItems.appendChild(entryHtml);
            this.setCountForEntry(entry.name, count);

            if(selected === 'selected')
                this.addQuickDeleteForEntry(entry);

            
            c += 1;
            fc += 1;
            if(hasSubOptions){

                let subOptionsHolder = this.htmlToElement('<div style="height:'+accordionDisplay+';" class="open accordion-group holder-'+entry.name+'"></div>');
                this.dropdownItems.appendChild(subOptionsHolder);
                let optArr = entry.options;
                if(entry.hasOwnProperty('optionsToShow'))
                    optArr = entry.optionsToShow;

                for (let j = 0; j < optArr.length; j++) {
                    if ((!anySubOptions || (anySubOptions && !this.options.ignoreMaxItemsWithSubOptions)) && c == this.options.maxItems)
                        break;

                    let optionEntry = optArr[j];

                    let selected = "";
                    if (this.selectedItems.some(x => x === optionEntry.name))
                        selected = "selected";
        
                    let count = this.getFilterOptionsNumbers(optionEntry, entry);
                    if (selected !== "selected" && count == 0 && this.options.hideEntriesWithZeroResults && !forceEmpty) {
                        continue;
                    }

                    if(selected == 'selected'){
                        subOptionsHolder.previousSibling.querySelector('.accordion-button').classList.toggle('open', true);
                        $(subOptionsHolder).css('height', 'auto');
                    }
                    
                    let entryHtml = this.htmlToElement('<a style="padding-top:'+ this.options.itemPaddingTopBottom + 'px; padding-bottom:'+ this.options.itemPaddingTopBottom +'px;" class="dropdown_' + optionEntry.name + ' ' + selected + ' suboption" onclick="window[\'' + this.uid + '\'].selectedEntry(\'' + optionEntry.name + '\', this, true, \'' + entry.name + '\');">' + (this.getTranslatedLabel(optionEntry)) + '<span class="countText"></span></a>');
                    subOptionsHolder.appendChild(entryHtml);
                    this.setCountForEntry(optionEntry.name, count);
        
                    if(selected === 'selected')
                        this.addQuickDeleteForEntry(optionEntry, entry.name);

                    fc += 1;

                    if(this.options.includeSubOptionsInMaxItems)
                        c += 1;
                }
            }

        }

        this.updateResults(fc);
        this.setCountForDropdown();
        
    }

    renderQuickDeleteForSelected(){
        for (const key in this.selectedItems) {
            if (this.selectedItems.hasOwnProperty(key)) {
                const entryName = this.selectedItems[key];
                let entry = this.entries.filter(x => x.name === entryName)[0];
                if(entry)
                    this.addQuickDeleteForEntry(entry);
                else{
                    //Might be a subentry
                    entry = this.entries.filter(x=> x.hasOwnProperty('options') && x.options.filter(y=> y.name == entryName).length > 0);
                    if(entry.length > 0)
                    {
                        entry = entry[0];
                        let subEntry = entry.options.find(x=> x.name === entryName);
                        this.addQuickDeleteForEntry(subEntry, entry.name);
                    }
                }
            }   
        }
    }

    addQuickDeleteForEntry(entry, parentEntryName = null){
        if(this.quickDeleteAreaElement === undefined)
            return;

        let item = this.quickDeleteAreaElement.querySelector('#qd'+this.uid + entry.name);
        if(item !== null){
            // item.remove();
            if(this.quickDeleteAreaElement.parentElement.classList.contains('hidden') >= 0){
                this.quickDeleteAreaElement.parentElement.classList.remove('hidden');
            }
            return;
           
        }

        if(parentEntryName != null){
            item = this.htmlToElement('<div class="quick-delete-item" id="qd'+(this.uid+entry.name)+'" style="padding:'+this.options.quickDeletePadding+'; height:'+this.options.quickDeleteHeight+'px" onclick="window[\'' + this.uid + '\'].removeQuickDeleteForEntryName(\'' + entry.name + '\', this, \'' + parentEntryName + '\');">'+ (this.getTranslatedLabel(entry)) +'</div>');
        }else{
            item = this.htmlToElement('<div class="quick-delete-item" id="qd'+(this.uid+entry.name)+'" style="padding:'+this.options.quickDeletePadding+'; height:'+this.options.quickDeleteHeight+'px" onclick="window[\'' + this.uid + '\'].removeQuickDeleteForEntryName(\'' + entry.name + '\', this);">'+ (this.getTranslatedLabel(entry)) +'</div>');
        }

       item.dataset.entryName = entry.name;
        item.dataset.uid = this.uid;

        this.quickDeleteAreaElement.appendChild(item);
        if(this.quickDeleteAreaElement.parentElement.classList.contains('hidden') >= 0){
            this.quickDeleteAreaElement.parentElement.classList.remove('hidden');
        }
    }

    removeQuickDeleteForEntryName(entryName, element, parentEntryName = null){
         if(parentEntryName != null){
            let entry = this.entries.filter(x => x.name === parentEntryName)[0];
            let subentry = entry.options.filter(x=> x.name === entryName)[0];
            this.removeQuickDeleteForEntry(subentry, true, parentEntryName);
        }else{
            let entry = this.entries.filter(x => x.name === entryName);
            entry = entry[0];
            this.removeQuickDeleteForEntry(entry);
        }
    }

    removeQuickDeleteForEntry(entry, runSelectedEntry = true, parentEntryName = null){
        if(this.quickDeleteAreaElement === undefined)
            return;

        let item = this.quickDeleteAreaElement.querySelector('#qd'+this.uid + entry.name);
        if(item !== null){
            item.remove();
        }

        if(this.quickDeleteAreaElement.childElementCount == 0){
            if(!this.quickDeleteAreaElement.parentElement.classList.contains('hidden'))
                this.quickDeleteAreaElement.parentElement.classList.add('hidden');
        }

        let element = this.dropdownItems.querySelector('.dropdown_'+entry.name);
        if(runSelectedEntry)
            this.selectedEntry(entry.name, element, false, parentEntryName);
    }

    removeQuickDeletes(){
        if(this.quickDeleteAreaElement === undefined)
            return;

        let items = this.quickDeleteAreaElement.querySelectorAll('[id*="qd'+this.uid+'"]');
        if(items !== null){
            items.forEach(i => i.remove());
        }

        if(this.quickDeleteAreaElement.childElementCount == 0){
            if(!this.quickDeleteAreaElement.parentElement.classList.contains('hidden'))
                this.quickDeleteAreaElement.parentElement.classList.add('hidden');
        }
    }

    updateResults(count) {
        if (!this.options.showResults) {
            this.resultsText.innerHTML = '';
            this.resultsText.style.display = 'none';
            return;
        }

        let text = this.getTranslation('filterDropdownResultsText', 'Showing {0} of {1}');
        text = text.replace('{0}', count);

        if(this.allowedEntries == null){
            let fullCount = this.entries.length;
            fullCount += this.entries.map(x=> x.options).flat().length;

            text = text.replace('{1}', fullCount);
        }else{
            let fullCount = this.allowedEntries.length;
            fullCount += this.allowedEntries.map(x=> x.options).flat().length;
           
            text = text.replace('{1}', fullCount);
        }
       

        this.resultsText.innerHTML = text;
        this.resultsText.style.display = 'block';
    }

    setSelectedItems(entryNames) {
        if (!this.options.multiSelect && entryNames.length > 1) {
            entryNames.length = 1;
        }

        this.selectedItems = entryNames;
        this.renderEntries(this.entries);
        this.renderQuickDeleteForSelected();
    }

    setCountForEntry(entryName, count, parentEntryName = null) {
        try{
            let entryHtml = this.dropdownItems.querySelector('.dropdown_' + entryName);
            if (!entryHtml) {
                console.log('ENTRY NOT FOUND');
                return;
            }
            let countSpan = entryHtml.querySelector('.countText');

            if (!this.options.showZeroSelectionCount && count <= 0) {
                countSpan.innerHTML = "";
                return;
            }

            countSpan.innerHTML = ('&nbsp;(' + count + ')');
        } catch(err){
            return;
        }
    }

    setCountForDropdown() {
        let countSpan = this.headerDiv.querySelector('.countText');

        if (!this.options.showSelectionCount || (this.selectedItems.length == 0 && !this.options.showZeroSelectionCount)) {
            countSpan.innerHTML = '';
            return;
        }

        countSpan.innerHTML = ('&nbsp;(' + this.selectedItems.length + ')');
    }

    selectedEntry(entryName, element, removeQuickSelect = true, parentEntryName = null, event = null) {

        if(event != null && event.target.classList.contains('accordion-button')){
            let accordion =  $('.holder-'+entryName);

            if(event.target.classList.contains('open')){
                event.target.classList.remove('open');
                accordion.css('height', '0');
            }else{
                event.target.classList.add('open');
                accordion.css('height', 'auto');
            }
            return;
        }

        if (!this.options.multiSelect && element !== null && !element.classList.contains('selected')) {
            this.clearAllSelected(false);
        }

        if(!this.options.multiSelect){
            element = this.dropdownItems.querySelector('.dropdown_'+entryName);
        }
        if(element != null)
            element.classList.toggle('selected');
        
        let entry = (parentEntryName == null)? this.entries.filter(x => x.name === entryName)[0] : this.entries.filter(x => x.name === parentEntryName)[0];
        if(parentEntryName != null){
            entry = entry.options.find(x=> x.name == entryName);
        }
        let active = false;
        if (element != null && element.classList.contains('selected')) {
            if (!this.selectedItems.some(x => x === entryName)){
                this.selectedItems.push(entry.name);
                active = true;
                this.addQuickDeleteForEntry(entry, parentEntryName);
            }
        } else {
            this.selectedItems = this.selectedItems.filter(x => x !== entryName);
            if(removeQuickSelect)
                this.removeQuickDeleteForEntry(entry, false, parentEntryName);
        }

        this.setCountForDropdown();

        if (typeof this.onchange === 'function') {
            this.onchange(entryName, active, element, this, parentEntryName);
        }

    }

    clearAllSelected(useCallback) {
        this.selectedItems = [];
        let nodeList = this.dropdownItems.querySelectorAll('a.selected');
        let i;
        for (i = 0; i < nodeList.length; i++) {
            nodeList[i].classList.remove('selected');
        }

        if (useCallback && typeof this.onclearall === 'function') {
            this.onclearall(this);
        }

        this.searchInput.value = "";

        this.renderEntries(this.entries);
        this.setCountForDropdown();
        this.removeQuickDeletes();
    }

    updateEntryCounts(){
        let nodeList = this.dropdownItems.querySelectorAll('a');
        let i;
        for (i = 0; i < nodeList.length; i++) {
            let entryName = Array.from(nodeList[i].classList).find(x=> x !== 'selected');
            let entry = this.entries.find(x => x.name === entryName);
            if(!entry)
                continue;
            let count = this.getFilterOptionsNumbers(entry);
            this.setCountForEntry(entry.name, count);
        }
    }
    getFilterOptionsNumbers(option, parentOption = null) {
        if (!window.AtheneumInstance)
            return 0;
      
        
        if (this.allowedEntries !== null){
            let altOption = this.allowedEntries.find(x=> x.name === option.name);
            if(altOption && altOption.hasOwnProperty('appliedAssets')){
                return altOption.appliedAssets;
            }
        }

        if (this.allowedEntries !== null && parentOption != null){
            let altOption = this.allowedEntries.find(x=> x.name === parentOption.name);
            if(altOption && altOption.hasOwnProperty('options')){
                altOption = altOption.options.find(x=> x.name == option.name);
                if(altOption && altOption.hasOwnProperty('appliedAssets')){
                    return altOption.appliedAssets;
                }
            }
            
        }

        if(option.hasOwnProperty('appliedAssets'))
            return option.appliedAssets;

        let filter = this.filterData;
        let key = filter.name;
        
        let tag = window.AtheneumInstance.Admin.tags?.find(x=> x.name === key);
        if(!tag)
            return 0;

        let tagOpt = tag.options.find(x=> x.name === option.name);
        if(!tagOpt)
            return 0;

        return tagOpt.assetIds?.length || 0;
    }
}
